
import { defineComponent } from '@vue/composition-api';
import { mapGetters, mapActions } from 'vuex';
import IllinoisSidebar from '../components/SidebarComponents/Sidebar.vue';
import IllinoisHeader from '../components/Header.vue';
import { Sport } from '../../../../types/events';
import { MyBet } from '../../../../types/sport';
import GenericSkinListener from '@/components/generic/GenericSkinListener.vue';
import IllinoisCart from '../components/CartComponents/Cart.vue';

import LoadingSkeleton from '@/components/generic/LoadingSkeleton.vue';
const LiveTrackerIllinois = () => ({
  component: import(
    '@/components/IllinoisSport/components/LiveTrackerIllinois.vue'
  ),
  loading: LoadingSkeleton,
  timeout: 200
});
import SidebarLive from '../components/SidebarComponents/SidebarLive.vue';
import BetOutcomeModal from '../components/CartComponents/BetOutcomeModal.vue';
import BetDetailModal from '../components/MyBetsComponents/BetDetailModal.vue';
import BetListModal from '../components/MyBetsComponents/BetListModal.vue';
import NotificationContainer from '../components/NotificationContainer.vue';
import Notification from '../components/Notification.vue';
export default defineComponent({
  name: 'IllinoisMain',
  components: {
    IllinoisHeader,
    IllinoisSidebar,
    GenericSkinListener,
    IllinoisCart,
    SidebarLive,
    LiveTrackerIllinois,
    BetOutcomeModal,
    BetDetailModal,
    BetListModal,
    NotificationContainer,
    Notification
  },
  data() {
    return {
      urlCloudfront:
        process.env.VUE_APP_URL_CLOUDFRONT + '/illinoisSlider/event-bg.webp',
      showMobileSidebar: false,
      sportId: window.sportId != null ? window.sportId : null,
      tournamentId: window.tournamentId != null ? window.tournamentId : null,
      eventId: window.eventId != null ? window.eventId : null,
      categoryId: window.categoryId != null ? window.categoryId : null,
      openlivesection:
        window.openlivesection != null ? window.openlivesection : false,
      activeNotifications: [] as Array<{
        id: string;
        bet: any;
        show: boolean;
      }>,
      oddsType: 'american',
      showBetDetailModal: false,
      selectedBet: null as MyBet | null,
      detailLoading: false,
      cashout: 0,
      cashoutPrematch: 0
    };
  },
  computed: {
    isCartOpen() {
      return this.$store.getters['cart/getIsCartOpen'];
    },
    showCart() {
      return this.$store.getters['IllinoisSport/getShowCart'];
    },
    isLivePage() {
      return this.$route.path.includes('/live');
    },
    isLiveDetailsPage() {
      return this.$route.params.eventId && this.isLivePage;
    },
    getViewLiveMatchTracker() {
      return this.$store.getters['odds/getViewLiveMatchTracker'];
    },
    getEventsLiveDetail() {
      return this.$store.getters['odds/getEventsLiveDetail'];
    },

    cart() {
      const cart = this.$store.getters['cart/getBet'];
      console.log('cart', cart);
      return cart;
    },
    // Dati provenienti dallo store
    illinoisSports() {
      return this.$store.getters['IllinoisSport/getSports'];
    },
    illinoisSportsAntepost() {
      return this.$store.getters['IllinoisSport/getSportsAntepost'];
    },
    isLoadingSports() {
      return this.$store.getters['IllinoisSport/getLoading'];
    },
    sportsError() {
      return this.$store.getters['IllinoisSport/getError'];
    },
    // Trasforma i dati dello store per la sidebar
    sportsData() {
      console.log('Transforming sports data from store:', this.illinoisSports);

      const transformedData = {
        antepost: this.illinoisSportsAntepost,
        allSports: this.illinoisSports
      };

      console.log('Transformed sports data:', transformedData);
      return transformedData;
    },
    useExternalTree() {
      return this.$store.getters['uiConfig/fullUIConfig'].useExternalTree;
    },
    // Computed per verificare se ci sono scommesse in accettazione
    hasBetsInAcceptance(): boolean {
      const accepting = this.$store.getters['cart/getAcceptingBets'] || [];
      const accepted = this.$store.getters['cart/getAcceptedBets'] || [];
      const withChange =
        this.$store.getters['cart/getAcceptedBetWithChange'] || [];
      const rejected = this.$store.getters['cart/getRejectedBets'] || [];
      return (
        accepting.length > 0 ||
        accepted.length > 0 ||
        withChange.length > 0 ||
        rejected.length > 0
      );
    },
    openMyBetModal() {
      return this.$store.getters['IllinoisSport/getOpenMyBetModal'];
    },
    acceptedWithChange() {
      return this.$store.getters['cart/getAcceptedBetWithChange'] || [];
    },
    getDetailMyBets() {
      return this.$store.getters['user/getDetailMyBets'];
    },
    getRulesManager() {
      return this.$store.getters['rules/getRulesManager'];
    },
    getRulesSkin() {
      return this.$store.getters['rules/getRulesSkin'];
    },
    getCashout() {
      return this.$store.getters['settings/getCashout'];
    },
    getCashoutLive() {
      return this.$store.getters['settings/getCashoutLive'];
    }
  },
  mounted() {
    console.log('Main component mounted');
    this.redirectFromSkin();
    // Carica gli sport dallo store senza bloccare il rendering
    console.log('Dispatching fetchSportsIfNeeded from Main...');
    this.$store.dispatch('IllinoisSport/fetchSportsIfNeeded');
    console.log('fetchSportsIfNeeded dispatched from Main');

    // Listener per aprire BetDetailModal da IllinoisMyBets
    this.$root.$on('openBetDetailModal', this.openBetDetailModal);
    this.oddsType = window.oddsType != null ? window.oddsType : 'american';
    this.$store.commit('odds/SET_ODDS_TYPE', this.oddsType);
  },
  beforeDestroy() {
    // Rimuovi listener eventi
    this.$root.$off('openBetDetailModal', this.openBetDetailModal);
  },
  watch: {
    $route() {
      this.resetScroll();
    },
    getEventsLiveDetail() {
      if (this.isLiveDetailsPage) {
        this.setViewLiveMatchTracker(true);
      }
    },
    isLiveDetailsPage(newVal) {
      this.setViewLiveMatchTracker(!!newVal);
    },
    // Quando showCart diventa true e non ci sono bet, apri automaticamente il carrello
    showCart(newVal: boolean) {
      if (newVal && this.cart.odds.length === 0 && !this.isCartOpen) {
        this.$store.dispatch('cart/setIsCartOpen', true);
      } else if (!newVal && this.cart.odds.length === 0 && this.isCartOpen) {
        // Se showCart diventa false e non ci sono bet, chiudi anche il carrello
        this.$store.dispatch('cart/setIsCartOpen', false);
      }
    },
    // Quando vengono aggiunte bet al carrello, il comportamento normale prevale
    // Se ci sono bet, showCart può essere ignorato (il carrello funziona normalmente)
    'cart.odds.length'(newLength: number) {
      // Quando vengono aggiunte bet e showCart era true, possiamo lasciarlo true
      // Il carrello continuerà a funzionare normalmente con le bet presenti
      // Quando vengono rimosse tutte le bet e showCart è false, chiudi il carrello
      if (newLength === 0 && !this.showCart && this.isCartOpen) {
        this.$store.dispatch('cart/setIsCartOpen', false);
      }
    },
    // Watcher per getDetailMyBets - aggiorna il bet quando cambia nello store
    getDetailMyBets: {
      async handler(val: MyBet) {
        if (this.showBetDetailModal && val && this.selectedBet) {
          this.selectedBet = val;
          await this.checkCashout(val);
          await this.checkCashoutPrematch(val);
        }
      },
      deep: true
    },
    // Watcher per le bet con controproposta
    acceptedWithChange(newBets: any[], oldBets: any[]) {
      if (!Array.isArray(newBets)) {
        return;
      }

      // Rileva nuove bet aggiunte
      const oldBetCodes = Array.isArray(oldBets)
        ? oldBets.map((bet: any) => bet.code)
        : [];
      const newBetCodes = newBets.map((bet: any) => bet.code);

      // Aggiungi notifiche per le nuove bet
      newBets.forEach((bet: any) => {
        if (!bet || !bet.code) return;

        // Se è una nuova bet (non era nell'array precedente)
        if (!oldBetCodes.includes(bet.code)) {
          // Verifica che non esista già una notifica per questa bet
          const existingNotification = this.activeNotifications.find(
            (n: any) => n.bet.code === bet.code
          );
          if (!existingNotification) {
            // Inizializza con show: false per attivare la transizione
            const notification = {
              id: bet.code + '_' + Date.now(),
              bet: bet,
              show: false
            };
            // Aggiungi all'inizio dell'array per renderizzare la notifica più recente per prima
            this.activeNotifications.unshift(notification);
            // Attiva la transizione nel nextTick
            this.$nextTick(() => {
              notification.show = true;
            });
          }
        }
      });

      // Rimuovi notifiche per le bet che non sono più nello store
      this.activeNotifications = this.activeNotifications.filter(
        (notification: any) => {
          const stillExists = newBetCodes.includes(notification.bet.code);
          if (!stillExists) {
            notification.show = false;
          }
          return stillExists;
        }
      );
    }
  },
  methods: {
    ...mapActions({
      setDetailMyBet: 'user/setDetailMyBet',
      fetchCashout: 'odds/fetchCashout',
      fetchEventResultAndTimeDetail: 'odds/fetchEventResultAndTimeDetail',
      fetchMyBets: 'user/fetchMyBets'
    }),
    t(key: string): string {
      return this.$t(key) as string;
    },
    openOrCloseCart(isCartOpen: boolean = !this.isCartOpen) {
      const newState = isCartOpen !== undefined ? isCartOpen : !this.isCartOpen;
      this.$store.dispatch('cart/setIsCartOpen', newState);
      // Sincronizza showCart solo quando non ci sono bet nel carrello
      // Se ci sono bet, il comportamento normale del carrello prevale
      if (this.cart.odds.length === 0) {
        if (!newState) {
          // Chiudendo il carrello senza bet, chiudi anche showCart
          this.$store.dispatch('IllinoisSport/setShowCart', false);
          window.parent.postMessage(
            {
              type: 'statusCart',
              status: false
            },
            '*'
          );
        } else {
          // Aprendo il carrello senza bet, apri anche showCart
          this.$store.dispatch('IllinoisSport/setShowCart', true);
        }
      }
      // Se ci sono bet, non modificare showCart - il carrello funziona normalmente
    },
    setViewLiveMatchTracker(status: boolean) {
      this.$store.dispatch('odds/setViewLiveMatchTracker', status);
    },

    onSportSelected(sport: Sport) {
      // Gestione selezione sport
      console.log('Sport selezionato:', sport);

      // Distingui tra sport principale e sottomenu
      if (sport.hasSubmenu) {
        console.log('Sport con sottomenu selezionato:', sport.name);
      } else {
        console.log('Sport senza sottomenu selezionato:', sport.name);
        // Naviga alla pagina dello sport
        this.$router.push(`/sport/${sport.id}`);
      }
    },
    resetScroll(): void {
      const el = this.$refs['scrollContainer'] as HTMLElement | undefined;
      if (el) {
        el.scrollTop = 0;
        el.scrollLeft = 0;
      } else {
        window.scrollTo(0, 0);
      }
    },

    setActiveSport(selectedSport) {
      // Reset tutti gli sport a non attivi
      if (this.illinoisSports) {
        this.illinoisSports.forEach(sport => {
          sport.isActive = false;
        });
      }

      if (this.illinoisSportsAntepost) {
        this.illinoisSportsAntepost.forEach(sport => {
          sport.isActive = false;
        });
      }

      // Imposta il sport selezionato come attivo
      selectedSport.isActive = true;

      console.log('Sport impostato come attivo:', selectedSport.name);
    },
    redirectFromSkin() {
      console.log(
        'redirectFromSkin',
        this.sportId,
        this.categoryId,
        this.tournamentId,
        this.eventId,
        this.openlivesection
      );
      if (
        this.openlivesection &&
        (this.openlivesection === 'true' || this.openlivesection === true)
      ) {
        console.log('openlivesection');
        this.$router.push(`/live`);
      } else if (
        this.eventId &&
        this.sportId &&
        this.categoryId &&
        this.tournamentId
      ) {
        console.log('eventId');
        this.$router.push(
          `/sport/${this.sportId}/category/${this.categoryId}/tournament/${this.tournamentId}/event/${this.eventId}`
        );
      } else if (this.tournamentId && this.sportId && this.categoryId) {
        console.log('tournamentId');
        this.$router.push(
          `/sport/${this.sportId}/category/${this.categoryId}/tournament/${this.tournamentId}`
        );
      } else if (this.sportId) {
        console.log('sportId');
        this.$router.push(`/sport/${this.sportId}`);
      } /* else {
        console.log('home');
        this.$router.push(`/`);
      } */
    },
    closeBetListModal(): void {
      this.$store.dispatch('IllinoisSport/setOpenMyBetModal', false);
    },
    handleSelectBetFromList(bet: any): void {
      this.$store.dispatch('IllinoisSport/setOpenMyBetModal', false);
      // Qui si potrebbe aprire il detail modal se necessario
    },
    removeNotification(id: string) {
      const index = this.activeNotifications.findIndex((n: any) => n.id === id);
      if (index >= 0) {
        this.activeNotifications[index].show = false;
        this.$nextTick(() => {
          this.activeNotifications.splice(index, 1);
        });
      }
    },
    handleNotificationClick(betCode: string) {
      // Apri il carrello se non è già aperto
      if (!this.isCartOpen) {
        this.openOrCloseCart(true);
      }
      // Aspetta che il carrello sia aperto prima di cambiare tab
      this.$nextTick(() => {
        const cartRef = this.$refs.cartRef as any;
        if (cartRef && cartRef.handleOpenCartPending) {
          cartRef.handleOpenCartPending();
        }
      });
    },
    handleNotificationClose(betCode: string) {
      // Rimuovi la notifica quando viene chiusa manualmente o automaticamente
      const notification = this.activeNotifications.find(
        (n: any) => n.bet.code === betCode
      );
      if (notification) {
        this.removeNotification(notification.id);
      }
    },
    async openBetDetailModal(bet: MyBet): Promise<void> {
      this.detailLoading = true;
      this.selectedBet = bet;
      this.showBetDetailModal = true;

      try {
        await this.checkCashout(bet);
        await this.checkCashoutPrematch(bet);

        if (bet.result === 'pending') {
          for (let i = 0; i < bet.odds.length; i++) {
            const data = await this.getLiveDate(bet.odds[i].event_source);
            if (data && data.livescore) {
              const time_actual = data.livescore.Scoreboard?.Time || 0;
              const result_actual = data.livescore.Scoreboard?.Results || [];
              bet.odds[i].show_time = true;
              bet.odds[i].time_actual = Number(time_actual) / 60;
              bet.odds[i].result_actual_home = this.getResult(
                result_actual,
                'home'
              );
              bet.odds[i].result_actual_away = this.getResult(
                result_actual,
                'away'
              );
            } else {
              bet.odds[i].show_time = false;
              bet.odds[i].time_actual = '';
              bet.odds[i].result_actual_home = '';
              bet.odds[i].result_actual_away = '';
            }
          }
        }

        this.setDetailMyBet(bet);
      } catch (error) {
        console.error('Error opening bet detail:', error);
      } finally {
        this.detailLoading = false;
      }
    },
    closeBetDetailModal(): void {
      this.showBetDetailModal = false;
      this.selectedBet = null;
      this.cashout = 0;
      this.cashoutPrematch = 0;
    },
    handleBetDetailCashoutSuccess(): void {
      this.closeBetDetailModal();
      // Ricarica le bet se necessario
      this.$root.$emit('refreshMyBets');
    },
    handleBetDetailCashoutError(): void {
      // Gestisci errore se necessario
    },
    async getLiveDate(eventSource: number): Promise<{
      livescore?: {
        Scoreboard?: {
          Time?: number;
          Results?: Array<{ Position: string; Value: string }>;
        };
      };
    } | null> {
      try {
        const data = await this.fetchEventResultAndTimeDetail({
          source: eventSource
        });
        return data;
      } catch {
        return null;
      }
    },
    getResult(
      result: Array<{ Position: string; Value: string }>,
      team: string
    ): number | string {
      if (!result || !Array.isArray(result)) return 0;
      const position = team === 'home' ? '1' : '2';
      const point = result.find(r => r.Position === position);
      return point ? +point.Value : 0;
    },
    async checkCashout(bet: MyBet): Promise<void> {
      if (bet.type === 'integral' || bet.type === 'system') {
        this.cashout = 0;
        return;
      }

      if (!this.getCashoutLive) {
        this.cashout = 0;
        return;
      }

      const rules_skin = this.getRulesSkin || [];
      const rules_manager = this.getRulesManager || [];

      let rules_cashout_percentage = rules_skin.find(
        (r: { detail?: { context?: number }; type?: string }) =>
          r.detail?.context === 1 && r.type === 'percentage'
      );
      if (!rules_cashout_percentage) {
        rules_cashout_percentage = rules_manager.find(
          (r: { detail?: { context?: number }; type?: string }) =>
            r.detail?.context === 1 && r.type === 'percentage'
        );
      }

      const percentage_bookmaker =
        rules_cashout_percentage?.detail?.value ?? 0.97;
      const amount_real = Number(bet.amount_real);
      const bet_result = bet.result;
      const applicabile: string[] = [];
      const moltiplicatore: number[] = [];

      for (let i = 0; i < bet.odds.length; i++) {
        const odd = bet.odds[i];
        const id_outcome = odd.id_outcome;
        const odd_value = Number(odd.outcome_odd_value_for_order);
        const unique_id = odd.unique_id;
        const type_event = odd.type;
        const ext_id = odd.ext_id;

        if (odd_value > 7) {
          this.cashout = 0;
          return;
        }

        try {
          const odds_instant = await this.fetchCashout({
            id: odd.event_source,
            outcome_id: id_outcome,
            unique_id: unique_id,
            ext_id: ext_id
          });

          if (odds_instant && odds_instant.length > 0) {
            for (const item of odds_instant) {
              if (
                item.odds &&
                item.odds.outcome?._attributes?.id === id_outcome
              ) {
                if (item.livescore) {
                  bet.odds[i].match_livescore = item.livescore;
                }
                bet.odds[i].sport_event_status =
                  item.sport_event_status?._attributes?.status;

                const odd_value_actual = item.status?.odds || 0;
                const status_odd = item.status?.status;

                const vincita = amount_real * odd_value;
                const probabilita = 1 / odd_value_actual;
                const vincita_nuova =
                  (vincita * probabilita * percentage_bookmaker) / amount_real;

                if (
                  type_event === 'live' &&
                  (status_odd === 1 || status_odd === 3) &&
                  bet_result === 'pending' &&
                  odd_value_actual <= 7
                ) {
                  applicabile.push('true');
                  moltiplicatore.push(vincita_nuova);
                } else {
                  applicabile.push('false');
                }
              }
            }
          }
        } catch (error) {
          console.error('Error checking cashout:', error);
          applicabile.push('false');
        }
      }

      if (!applicabile.includes('false') && moltiplicatore.length > 0) {
        const importo_cashout =
          moltiplicatore.reduce((a, b) => a * b, 1) * amount_real;
        this.cashout = importo_cashout > 0 ? Math.abs(importo_cashout) : 0;
      } else {
        this.cashout = 0;
      }
    },
    async checkCashoutPrematch(bet: MyBet): Promise<void> {
      try {
        if (bet.type === 'integral' || bet.type === 'system') {
          this.cashoutPrematch = 0;
          return;
        }

        if (!this.getCashout) {
          this.cashoutPrematch = 0;
          return;
        }

        const rules_skin = this.getRulesSkin || [];
        const rules_manager = this.getRulesManager || [];

        let rules_cashout_percentage = rules_skin.find(
          (r: { detail?: { context?: number }; type?: string }) =>
            r.detail?.context === 0 && r.type === 'percentage'
        );
        if (!rules_cashout_percentage) {
          rules_cashout_percentage = rules_manager.find(
            (r: { detail?: { context?: number }; type?: string }) =>
              r.detail?.context === 0 && r.type === 'percentage'
          );
        }

        const cashoutrisk = rules_cashout_percentage?.detail?.value ?? 20;

        let rules_cashout_min_events = rules_skin.find(
          (r: { detail?: { context?: number }; type?: string }) =>
            r.detail?.context === 0 && r.type === 'min_event'
        );
        if (!rules_cashout_min_events) {
          rules_cashout_min_events = rules_manager.find(
            (r: { detail?: { context?: number }; type?: string }) =>
              r.detail?.context === 0 && r.type === 'min_event'
          );
        }
        const min_events_cashout = rules_cashout_min_events?.detail?.value ?? 2;

        let rules_cashout_min_odds = rules_skin.find(
          (r: { detail?: { context?: number }; type?: string }) =>
            r.detail?.context === 0 && r.type === 'min_odds'
        );
        if (!rules_cashout_min_odds) {
          rules_cashout_min_odds = rules_manager.find(
            (r: { detail?: { context?: number }; type?: string }) =>
              r.detail?.context === 0 && r.type === 'min_odds'
          );
        }
        const min_odds_cashout = rules_cashout_min_odds?.detail?.value ?? 1.2;

        let rules_cashout_max_events = rules_skin.find(
          (r: { detail?: { context?: number }; type?: string }) =>
            r.detail?.context === 0 && r.type === 'max_event'
        );
        if (!rules_cashout_max_events) {
          rules_cashout_max_events = rules_manager.find(
            (r: { detail?: { context?: number }; type?: string }) =>
              r.detail?.context === 0 && r.type === 'max_event'
          );
        }
        const max_events_cashout = rules_cashout_max_events?.detail?.value ?? 7;

        const nr_events = bet.odds.length;
        const perc_events = 100 / nr_events;
        const value_percent_cashout =
          100 - (perc_events - (perc_events * cashoutrisk) / 100);
        const amount_real = Number(bet.amount_real);
        const bet_result = bet.result;
        const bet_context = bet.bet_context;
        const in_checkout: number[] = [];

        if (bet_context === 'prematch' && bet_result === 'pending') {
          const date_now = new Date();
          let evento_in_corso = false;
          const count_events = bet.odds.length;

          if (
            count_events >= min_events_cashout &&
            count_events <= max_events_cashout
          ) {
            for (let i = 0; i < count_events; i++) {
              const odd = bet.odds[i];
              const event_defined = odd.defined ? true : false;
              let odd_value = Number(odd.outcome_odd_value_for_order);
              const event_result = odd.result ? true : false;
              const event_half_won = odd.half_won || false;
              const event_time = odd.time;
              const status_event = odd.status_event;

              if (odd_value < min_odds_cashout) {
                this.cashoutPrematch = 0;
                return;
              }

              if (status_event !== 1) {
                this.cashoutPrematch = 0;
                return;
              }

              if (event_defined && (event_result || event_half_won)) {
                if (event_half_won) {
                  odd_value = odd_value / 2;
                }
                in_checkout.push(odd_value);
              } else if (!event_defined && event_time < date_now.getTime()) {
                evento_in_corso = true;
              }
            }
          }

          if (in_checkout.length > 0 && !evento_in_corso) {
            let quota = 1;
            for (const val of in_checkout) {
              quota *= val;
            }

            const vincita = amount_real * quota;
            const profitto = vincita - amount_real;
            const valore_cashout = (profitto * value_percent_cashout) / 100;
            const importo_cashout = profitto - Math.abs(valore_cashout);
            const real_cashout = importo_cashout + amount_real;

            this.cashoutPrematch =
              real_cashout > 0 ? Math.abs(real_cashout) : 0;
          } else {
            this.cashoutPrematch = 0;
          }
        } else {
          this.cashoutPrematch = 0;
        }
      } catch (e) {
        console.error('Error checking cashout prematch:', e);
        this.cashoutPrematch = 0;
      }
    }
  }
});
